import styled from "styled-components";

export const HotelStayList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(6)};
	list-style: none;
`;

export const HotelStayListItemHeading = styled.h2`
	display: flex;
	color: ${({ theme }) => theme.colors.palette.grey[90]};
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
	font-size: ${({ theme }) => theme.fonts.sizes.large};
	gap: ${({ theme }) => theme.spacing(4)};
`;

export const HotelStayProcessedInfo = styled.div`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(1)};
`;
